var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "culture-card"
  }, [_c("section", {
    staticClass: "culture-card__top"
  }, [_c("img", {
    attrs: {
      src: require(`@/assets/images/aboutUS/${_vm.img}`),
      alt: ""
    }
  }), _c("section", {
    staticClass: "desc puhui-M"
  }, _vm._l(_vm.paragraph, function (item, index) {
    return _c("p", {
      key: index
    }, [_vm._v(_vm._s(item))]);
  }), 0)]), _c("section", {
    staticClass: "culture-card__bottom"
  }, [_c("h5", [_vm._v(_vm._s(_vm.title))])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };